import { TableCellProps } from '../models';
import styles from './nameCell.module.scss';
import usePermissions from '../../../../../../shared/hooks/usePermissions';
import PERMISSIONS from '../../../../../../shared/permissions';

function NameCell({ row }: TableCellProps) {
  const { hasAccess } = usePermissions();
  return (
    <span className={styles.cell}>
      <span className={`${styles.textContent} d-block`} data-exclude-lg>
        {row.original.name ? row.original.name : '...'}
      </span>
      <span className={`${styles.textContent} d-block`} data-exclude-lg>
        {row.original.invitationEmail ? row.original.invitationEmail : '...'}
      </span>
      <span className={`${styles.textContent} d-block`} data-exclude-lg>
        {row.original.phoneNumber ? row.original.phoneNumber : ''}
      </span>
      {hasAccess({ permissions: [PERMISSIONS.ManageElevatedAdmins] }) && (
        <span className={`${styles.textContent} d-block`}>
          ID: {row.original.personId ? row.original.personId : 'N/A'}
        </span>
      )}
    </span>
  );
}

export default NameCell;
